import { Route, Routes } from 'react-router'

import PublicPageNotFound from '@/pages/PublicPageNotFound'

import PrivateLayout from './PrivateLayout'
import { generateRoutes } from './routes'

const { privateRoutes, publicRoutes } = generateRoutes()

const AppRouter = () => {
  const punchoutRoute = publicRoutes.find((route) => route.path === 'punchout')
  const registrationRoutes = publicRoutes.filter((route) => route.path?.startsWith('registration'))
  const otherPublicRoutes = publicRoutes.filter(
    (route) => route.path !== 'punchout' && !route.path?.startsWith('registration'),
  )

  return (
    <Routes>
      {punchoutRoute && <Route key="punchout" element={punchoutRoute.element} path="punchout/*" />}
      {registrationRoutes.map(({ path, element }) => (
        <Route key={path} element={element} path={path} />
      ))}
      <Route path="/:locale">
        {otherPublicRoutes.map(({ path, element }) => (
          <Route key={path} element={element} path={path} />
        ))}
        <Route element={<PrivateLayout />}>
          {privateRoutes.map(({ path, element }) => (
            <Route key={path} element={element} path={path} />
          ))}
        </Route>
      </Route>
      <Route element={<PublicPageNotFound />} path="*" />
    </Routes>
  )
}

export default AppRouter
